<template>
    <el-dialog title="打款编辑" :visible.sync="dialogShow" @close="closeDialog" @open="openDialog">

        <el-form :model="form" :rules="rules" ref="form">

            <el-form-item label="打款对象" :label-width="formLabelWidth" prop="to">
                <el-col :span="12">
                    <el-select v-model="form.to" placeholder="--请选择--">
                        <el-option label="商户" value="01"></el-option>
                        <el-option label="代理商" value="02"></el-option>
                    </el-select>
                </el-col>
            </el-form-item>

            <el-form-item v-show="form.to === '01'"  label="选择商户" :label-width="formLabelWidth" prop="appId">
                <el-col :span="12">
                    <el-select v-model="form.appId" placeholder="--请选择--">
                        <el-option v-for="mer in merList" :label="mer.merchantName" :value="mer.appId"
                                   :key="mer.appId"></el-option>
                    </el-select>
                </el-col>
            </el-form-item>

            <el-form-item v-show="form.to === '02'"  label="选择代理商" :label-width="formLabelWidth" prop="agentId">
                <el-col :span="12">
                    <el-select v-model="form.agentId" placeholder="--请选择--">
                        <el-option v-for="agent in agentList" :label="agent.agentName" :value="agent.agentId"
                                   :key="agent.agentId"></el-option>
                    </el-select>
                </el-col>
            </el-form-item>

            <el-form-item label="提现金额" :label-width="formLabelWidth" prop="amount">
                <el-col :span="12">
                    <el-input v-model="form.amount" autocomplete="off" placeholder="请输入提现金额"></el-input>
                </el-col>
            </el-form-item>

            <el-form-item label="提现银行" :label-width="formLabelWidth" prop="bankName">
                <el-col :span="12">
                    <el-select v-model="form.bankName" placeholder="--请选择--">
                        <el-option label="工商银行" value="工商银行"></el-option>
                        <el-option label="农业银行" value="农业银行"></el-option>
                        <el-option label="中国银行" value="中国银行"></el-option>
                        <el-option label="建设银行" value="建设银行"></el-option>
                        <el-option label="交通银行" value="交通银行"></el-option>
                        <el-option label="中信银行" value="中信银行"></el-option>
                        <el-option label="光大银行" value="光大银行"></el-option>
                        <el-option label="华夏银行" value="华夏银行"></el-option>
                        <el-option label="民生银行" value="民生银行"></el-option>
                        <el-option label="广东发展银行" value="广东发展银行"></el-option>
                        <el-option label="平安银行" value="平安银行"></el-option>
                        <el-option label="招商银行" value="招商银行"></el-option>
                        <el-option label="兴业银行" value="兴业银行"></el-option>
                        <el-option label="浦东发展银行" value="浦东发展银行"></el-option>
                        <el-option label="北京银行" value="北京银行"></el-option>
                    </el-select>
                </el-col>
            </el-form-item>

            <el-form-item label="姓名" :label-width="formLabelWidth" prop="certName">
                <el-col :span="12">
                    <el-input v-model="form.certName" autocomplete="off" placeholder="请输入姓名"></el-input>
                </el-col>
            </el-form-item>

            <el-form-item label="银行卡号" :label-width="formLabelWidth" prop="bankCardNo">
                <el-col :span="12">
                    <el-input v-model="form.bankCardNo" autocomplete="off" placeholder="请输入银行卡号"></el-input>
                </el-col>
            </el-form-item>

        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">取 消</el-button>
            <el-button type="primary" @click="saveMerchant">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "SystemEdit",
        props: {
            show: Boolean,
            formData: Object,
            action: String
        },

        created() {

            this.$axios.get("/agent/selectListChild", {params: {}}).then(res => {
                this.agentList = res.data.list;
            });

            this.$axios.get("/merchant/selectListForAgent", {params: {}}).then(res => {
                this.merList = res.data.list;
            });

        },
        data() {
            return {
                dialogShow: this.show,
                form: {
                    appId: "",
                    agentId: "",
                    certName: "",
                    bankCardNo: "",
                    amount: "",
                    bankName: "",
                    to: ""
                },
                agentList: [],
                formLabelWidth: '120px',
                rules: {
                    to: [
                        {required: true, message: '请选择打款对象', trigger: 'blur'}
                    ],
                    amount: [
                        {required: true, message: '请输入提现金额', trigger: 'blur'}
                    ],
                    bankCardNo: [
                        {required: true, message: '请输入正确的银行卡号', trigger: 'blur'},
                        {min: 15, max: 20, message: '请输入6到20个数字', trigger: 'blur'},
                    ],
                    bankName: [
                        {required: true, message: '请选择银行卡', trigger: 'blur'}
                    ],
                    certName: [
                        {required: true, message: '请输入姓名', trigger: 'blur'}
                    ]
                },
                merList: []
            }
        },


        methods: {

            agentNameChange() {

            },

            openDialog() {
                if (this.formData != null) {

                } else {
                    this.$refs['form'] && this.$refs['form'].resetFields(); //关闭的时候重置表单
                }
            },
            closeDialog() {
                this.dialogShow = false;
                this.$refs['form'].resetFields(); //关闭的时候重置表单
                this.$emit('update:show', false);
            },

            saveMerchant() {
                if (this.action === "callMoney") {
                    this.$refs['form'].validate((valid) => {
                        if (valid) {
                            this.axios.post("/withdraw/makeMoney", this.form).then(res => {
                                if (res.code === 200) {

                                    this.$notify({
                                        title: '添加成功',
                                        message: res.msg,
                                        type: 'success'
                                    });

                                    this.$bus.$emit('refresh'); //通知刷新

                                    this.closeDialog();
                                } else {

                                    this.$notify.error({
                                        title: '添加失败',
                                        message: res.msg,
                                    });
                                }
                            })
                        } else {
                            return false;
                        }
                    });
                }
            }
        },
        watch: {
            show(newVal) {
                this.dialogShow = newVal;
            }
        },
    }
</script>

<style scoped>

</style>